import React, {useState, useEffect} from 'react'
import { Menu, Typography, Avatar, Button} from 'antd'
import {Link} from 'react-router-dom'
import {BulbTwoTone, MenuOutlined } from '@ant-design/icons'
import icon from '../images/cryptocurrency.png'
const {Title} =Typography
const Navbar = () => {
    const [activeMenu, setActiveMenu] = useState(true);
  const [screenSize, setScreenSize] = useState(undefined);

  useEffect(() => {
    const handleResize = () => setScreenSize(window.innerWidth);

    window.addEventListener('resize', handleResize);

    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (screenSize <= 800) {
      setActiveMenu(false);
    } else {
      setActiveMenu(true);
    }
  }, [screenSize]);
    return (
        <div className="nav-container">
            <div className="logo-container">
                <Avatar src={icon} size="large"/>
                <Title level={2} className="logo">
                    <Link to="/">Oh My Crypto</Link>
                </Title>
                <Button className='menu-control-container' onClick={() => setActiveMenu(!activeMenu)}><MenuOutlined/></Button>
            </div>
            {activeMenu &&(
            <Menu theme="dark">
                <Menu.Item icon={<BulbTwoTone />}>
                    <Link to="/">Homepage</Link>
                </Menu.Item>
                <Menu.Item icon={<BulbTwoTone />}>
                    <Link to="/cryptocurrencies">Cryptocurrencies</Link>
                </Menu.Item>
                 
                <Menu.Item icon={<BulbTwoTone />}>
                    <Link to="/exchanges">Exchanges</Link>
                </Menu.Item>
                <Menu.Item icon={<BulbTwoTone />}>
                    <Link to="/news">News</Link>
                </Menu.Item>
            </Menu>
            )}
        </div>
    )
}

export default Navbar
